/* GT bundelbouwer (V6, 2026-09-30). Leest de config uit snippets/gt-bundle-builder.liquid.
   Per vak kiest de klant maat en/of kleur in een paneel met echte productfoto's; het paneel gaat
   zelf door naar het volgende lege vak. De eigen knop vult de properties in en dient het
   Dawn-formulier in (product-form doet de rest: winkelwagen-lade, foutmelding). */
(function () {
  'use strict';

  // type -> welke productdata, welke optie is maat/kleur
  var TYPES = {
    sok:   { maat: 'o1', kleur: 'o2' },
    ultra: { maat: 'o2', kleur: 'o1' },
    kous:  { kleur: 'o1' },
    mini:  { kleur: 'o1' },
    shin:  { maat: 'o1', tegelMaat: true }
  };
  // volgorde = meest verkocht laatste 180 dagen (stand 2026-09-29). Per kleur een variant-ID, want
  // Shopify vertaalt de kleurnamen (DE 'Königsblau'), dus sorteren op de Nederlandse naam werkt niet.
  var ORDE = {
    // Classic: Wit, Zwart, Rood, Royaal Blauw, Groen, Paars, Geel, Navy Blauw, Oranje, Roze
    sok: [49038669185353, 49038669250889, 50611604259145, 50611604291913, 50611604324681, 51922962022729, 51922961957193, 51922961989961, 52972919161161, 51922962055497],
    // Pro Sleeve: Zwart, Royaal Blauw, Rood, Groen, Paars, Oranje, Wit, Navy Blauw, Geel
    kous: [51920955605321, 51920955670857, 51920955638089, 51920955703625, 51920955769161, 53834694656329, 51920955572553, 51920955801929, 51920955736393]
  };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function uniek(a) { return a.filter(function (x, i) { return a.indexOf(x) === i; }); }
  function maatGetal(m) { var r = /(\d+)/.exec(m); return r ? +r[1] : 0; }

  function init(root) {
    if (root.dataset.gtbInit) return;
    var cfgEl = root.querySelector('script[type="application/json"]');
    if (!cfgEl) return;
    root.dataset.gtbInit = '1';
    var C = JSON.parse(cfgEl.textContent);
    var T = C.t;
    var info = root.closest('.product__info-container');
    if (info) info.classList.add('gtb-actief');

    var form = document.getElementById(C.formId) || (root.closest('.shopify-section') || document).querySelector('form[data-type="add-to-cart-form"]');
    var dawnKnop = form && form.querySelector('button[name="add"]');

    // --- vakken en namen ---------------------------------------------------
    var telling = {};
    C.vakken.forEach(function (t) { telling[t] = (telling[t] || 0) + 1; });
    var nr = {};
    var vakken = C.vakken.map(function (t) {
      nr[t] = (nr[t] || 0) + 1;
      var meer = telling[t] > 1;
      var n = T.naam[t], k = T.kort[t];
      return {
        type: t, maat: null, kleur: null,
        naam: meer ? n + ' ' + T.nr[t].replace('{n}', nr[t]) : n,
        kort: meer ? k + ' ' + T.nr[t].replace('{n}', nr[t]) : k,
        // korte verwijzing voor de tegel 'Zelfde als ...': 'paar 1' bij sokken, anders 'kous 1'
        ref: meer && (t === 'sok' || t === 'ultra') ? T.nr[t].replace('{n}', nr[t]) : (meer ? k + ' ' + T.nr[t].replace('{n}', nr[t]) : k),
        kaart: C.vakken.length > 3 ? (meer ? T.kaart[t] + ' ' + nr[t] : T.kaart[t]) : (meer ? n + ' ' + T.nr[t].replace('{n}', nr[t]) : n)
      };
    });

    function data(t) { return (C.data[t] || []).filter(function (v) { return v.a; }); }
    function maten(t) {
      var d = TYPES[t];
      var m = uniek(data(t).map(function (v) { return v[d.maat]; }));
      return t === 'shin' ? m : m.sort(function (a, b) { return maatGetal(a) - maatGetal(b); });
    }
    function kleuren(t, maat) {
      var d = TYPES[t];
      var k = uniek(data(t).filter(function (v) { return !d.maat || !maat || v[d.maat] === maat; }).map(function (v) { return v[d.kleur]; }));
      var o = ORDE[t] || [], rang = {};
      (C.data[t] || []).forEach(function (x) { var r = o.indexOf(x.id); if (r >= 0) rang[x[d.kleur]] = r; });
      return k.sort(function (a, b) {
        var ia = a in rang ? rang[a] : 99, ib = b in rang ? rang[b] : 99;
        return ia - ib;
      });
    }
    function foto(t, maat, kleur) {
      var d = TYPES[t];
      var v = data(t).find(function (x) { return (!d.maat || !maat || x[d.maat] === maat) && (!d.kleur || !kleur || x[d.kleur] === kleur); });
      return v ? v.img : '';
    }
    function kl(k) { return (T.kleur && T.kleur[k]) || k; }
    function klaar(v) { var d = TYPES[v.type]; return (!d.maat || !!v.maat) && (!d.kleur || !!v.kleur); }
    function eersteOpen(vanaf) {
      var n = vakken.length;
      for (var i = 0; i < n; i++) { var j = ((vanaf || 0) + i) % n; if (!klaar(vakken[j])) return j; }
      return -1;
    }
    function vorigeGelijk(i) { for (var j = i - 1; j >= 0; j--) if (vakken[j].type === vakken[i].type) return vakken[j]; return null; }
    function maatKort(v) { return v.type === 'shin' ? v.maat.split(' (')[0] : v.maat.replace('EU ', ''); }
    function samenvatting(v) {
      if (!klaar(v)) return '';
      if (v.type === 'shin') return maatKort(v);
      return (v.maat ? maatKort(v) + ' · ' : '') + kl(v.kleur);
    }
    function propWaarde(v) {
      if (v.type === 'shin') return v.maat;
      return (v.maat ? v.maat + ' - ' : '') + kl(v.kleur);
    }

    // niet leverbaar in deze markt (bv. scheenbeschermers buiten BE/NL)?
    var leverbaar = C.vakken.every(function (t) { return data(t).length > 0; });

    // --- opbouw op de pagina ------------------------------------------------
    var kaartenEl = root.querySelector('.gtb__kaarten');
    var tellerEl = root.querySelector('.gtb__teller');
    var knop = root.querySelector('.gtb__knop');
    kaartenEl.style.setProperty('--gtb-n', vakken.length);

    if (!leverbaar || !C.beschikbaar) {
      knop.disabled = true;
      knop.textContent = leverbaar ? T.uitverkocht : T.nietLeverbaar;
    }

    var balk = document.createElement('div');
    balk.className = 'gtb-balk';
    balk.innerHTML = '<div class="gtb-balk__mini"></div><button type="button" class="gtb__knop"></button>';
    var scherm = document.createElement('div');
    scherm.className = 'gtb-scherm';
    var paneel = document.createElement('div');
    paneel.className = 'gtb-paneel';
    paneel.setAttribute('role', 'dialog');
    paneel.setAttribute('aria-modal', 'true');
    paneel.setAttribute('aria-labelledby', 'gtb-ptitel');
    paneel.innerHTML = '<div class="gtb-paneel__kop"><div class="gtb-paneel__greep"></div><div class="gtb-paneel__rij"><div><div class="gtb-paneel__stap"></div><p class="gtb-paneel__titel" id="gtb-ptitel"></p></div>' +
      '<button type="button" class="gtb-paneel__sluit" aria-label="' + esc(T.sluiten) + '">&times;</button></div><div class="gtb-paneel__stippen"></div></div><div class="gtb-paneel__inhoud"></div>';
    if (leverbaar && C.beschikbaar) document.body.appendChild(balk);
    document.body.appendChild(scherm);
    document.body.appendChild(paneel);
    var balkKnop = balk.querySelector('.gtb__knop');
    var inhoud = paneel.querySelector('.gtb-paneel__inhoud');
    var open = -1, laatsteTrigger = null;

    function knopTekst() {
      var i = eersteOpen(0);
      if (i < 0) return T.toevoegen + ' · ' + C.prijs;
      var v = vakken[i], d = TYPES[v.type];
      if (v.type === 'shin') return T.kiesMaatShin;
      if (d.maat && !v.maat) return T.kiesMaat;
      return T.kiesKleur.replace('{x}', v.kort);
    }

    function teken() {
      var volg = eersteOpen(0);
      kaartenEl.innerHTML = vakken.map(function (v, i) {
        var vol = klaar(v);
        var cls = 'gtb__kaart' + (vol ? ' gtb__kaart--vol' : '') + (!vol && i === volg ? ' gtb__kaart--volgende' : '');
        var binnen = vol
          ? '<img src="' + esc(foto(v.type, v.maat, v.kleur)) + '" alt="" loading="lazy">' + (volg < 0 ? '<span class="gtb__wijzig">' + esc(T.wijzig) + '</span>' : '')
          : '<span class="gtb__plus" aria-hidden="true">+</span><span class="gtb__kies">' + esc(T.kies) + '</span>';
        // maat op regel 1, kleur op regel 2
        var sub = vol
          ? (v.maat ? '<span class="gtb__r">' + esc(maatKort(v)) + '</span>' : '') + (v.kleur ? '<span class="gtb__r">' + esc(kl(v.kleur)) + '</span>' : '')
          : esc(v.type === 'shin' ? T.subMaat : (TYPES[v.type].maat ? T.subMaatKleur : T.subKleur));
        return '<button type="button" class="' + cls + '" data-i="' + i + '" aria-label="' + esc(v.naam + ': ' + (vol ? samenvatting(v) : T.kies)) + '">' +
          '<div class="gtb__foto">' + binnen + '</div><div class="gtb__naam">' + esc(v.kaart) + '</div><div class="gtb__keuze">' + sub + '</div></button>';
      }).join('');
      var n = vakken.filter(klaar).length;
      tellerEl.textContent = T.teller.replace('{n}', n).replace('{t}', vakken.length);
      if (leverbaar && C.beschikbaar) {
        var af = volg < 0, txt = knopTekst();
        [knop, balkKnop].forEach(function (b) { b.textContent = txt; b.classList.toggle('gtb__knop--klaar', af); });
      }
      balk.querySelector('.gtb-balk__mini').innerHTML = vakken.map(function (v) {
        return '<span style="' + (klaar(v) ? 'background-image:url(' + esc(foto(v.type, v.maat, v.kleur)) + ')' : '') + '"></span>';
      }).join('');
    }

    function stippen() {
      paneel.querySelector('.gtb-paneel__stippen').innerHTML = vakken.map(function (v) { return '<i class="' + (klaar(v) ? 'ok' : '') + '"></i>'; }).join('');
    }

    function tegel(waarde, src, aan, label, sub, extraCls, pil) {
      return '<button type="button" class="gtb-tegel' + (extraCls ? ' ' + extraCls : '') + '" data-w="' + esc(waarde) + '" aria-pressed="' + (aan ? 'true' : 'false') + '"' + (pil ? ' aria-label="' + esc(pil.volledig + ': ' + label) + '" title="' + esc(pil.volledig) + '"' : '') + '>' +
        '<img src="' + esc(src) + '" alt="">' + (pil ? '<b class="gtb-tegel__pil" aria-hidden="true">= ' + esc(pil.kort) + '</b>' : '') + '<span>' + esc(label) + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span></button>';
    }

    function openPaneel(i) {
      if (!leverbaar || !C.beschikbaar) return;
      var v = vakken[i], d = TYPES[v.type], vorige = vorigeGelijk(i);
      if (open < 0) laatsteTrigger = document.activeElement;
      open = i;
      // maat van het vorige paar van hetzelfde type alvast overnemen
      if (d.maat && !v.maat && vorige && vorige.maat && maten(v.type).indexOf(vorige.maat) >= 0 && !d.tegelMaat) v.maat = vorige.maat;
      paneel.querySelector('.gtb-paneel__stap').textContent = T.stap.replace('{n}', i + 1).replace('{t}', vakken.length);
      paneel.querySelector('.gtb-paneel__titel').textContent = v.naam;
      stippen();
      var h = '';
      if (v.type === 'shin') {
        h += '<div class="gtb-vraag">' + esc(T.vraagShin) + ' <small>' + esc(T.hintShin) + '</small></div><div class="gtb-tegels gtb-tegels--2">' +
          maten('shin').map(function (m) {
            var delen = m.split(' - ');
            return tegel(m, foto('shin', m, null), v.maat === m, delen[0], delen[1] || '');
          }).join('') + '</div>';
      } else {
        if (d.maat) {
          var mlijst = maten(v.type);
          var nodig = !v.maat && !!v.kleur;
          h += '<div class="gtb-vraag' + (nodig ? ' gtb-vraag--nodig' : '') + '">' + esc(T.vraagMaat) + ' <small>' + esc(nodig ? T.kiesNogMaat : T.hintMaat) + '</small></div><div class="gtb-maten' + (nodig ? ' gtb-maten--nodig' : '') + '" style="--m:' + mlijst.length + '">' +
            mlijst.map(function (m) {
              return '<button type="button" class="gtb-maat" data-m="' + esc(m) + '" aria-pressed="' + (v.maat === m) + '">' + esc(m.replace('EU ', '')) + '</button>';
            }).join('') + '</div>';
        }
        var lijst = kleuren(v.type, v.maat);
        var dicht = false;
        var khint = dicht ? T.hintEerstMaat : (d.maat ? '' : (T.hintKous[v.type] || ''));
        h += '<div class="gtb-kleurvak' + (dicht ? ' gtb-kleurvak--dicht' : '') + '"><div class="gtb-vraag">' + esc(d.maat ? T.vraagKleur : T.vraagKleurVan.replace('{x}', v.kort)) + (khint ? ' <small>' + esc(khint) + '</small>' : '') + '</div><div class="gtb-tegels">';
        if (vorige && vorige.kleur && lijst.indexOf(vorige.kleur) >= 0) {
          // kleur van het vorige paar vooraan (1 tik voor dezelfde kleur), zonder label of groene rand (30-09, gebruiker)
          h += tegel(vorige.kleur, foto(v.type, v.maat, vorige.kleur), v.kleur === vorige.kleur, kl(vorige.kleur));
          lijst = lijst.filter(function (k) { return k !== vorige.kleur; });
        }
        h += lijst.map(function (k) { return tegel(k, foto(v.type, v.maat, k), v.kleur === k, kl(k)); }).join('') + '</div></div>';
      }
      inhoud.innerHTML = h;
      inhoud.scrollTop = 0;

      Array.prototype.forEach.call(inhoud.querySelectorAll('.gtb-maat'), function (b) {
        b.addEventListener('click', function () {
          v.maat = b.getAttribute('data-m');
          if (v.kleur && kleuren(v.type, v.maat).indexOf(v.kleur) < 0) v.kleur = null;
          teken(); openPaneel(i);
          if (klaar(v)) volgende(i);
        });
      });
      Array.prototype.forEach.call(inhoud.querySelectorAll('.gtb-tegel'), function (b) {
        b.addEventListener('click', function () {
          var w = b.getAttribute('data-w');
          if (v.type === 'shin') v.maat = w; else v.kleur = w;
          if (!klaar(v)) { teken(); stippen(); openPaneel(i); return; }
          Array.prototype.forEach.call(inhoud.querySelectorAll('.gtb-tegel'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          teken(); stippen();
          volgende(i);
        });
      });

      scherm.classList.add('gtb-scherm--open');
      paneel.classList.add('gtb-paneel--open');
      document.documentElement.classList.add('gtb-slot');
      balkCheck();
      var s = paneel.querySelector('.gtb-paneel__sluit');
      if (s) s.focus({ preventScroll: true });
    }

    var wachten = null;
    function volgende(i) {
      clearTimeout(wachten);
      wachten = setTimeout(function () {
        var j = eersteOpen(i + 1);
        if (j >= 0) { openPaneel(j); return; }
        sluit();
        knop.classList.remove('gtb__knop--puls'); void knop.offsetWidth; knop.classList.add('gtb__knop--puls');
      }, 260);
    }

    function sluit() {
      if (open < 0) return;
      open = -1;
      scherm.classList.remove('gtb-scherm--open');
      paneel.classList.remove('gtb-paneel--open');
      document.documentElement.classList.remove('gtb-slot');
      balkCheck();
      if (laatsteTrigger && laatsteTrigger.focus) laatsteTrigger.focus({ preventScroll: true });
    }
    paneel.querySelector('.gtb-paneel__sluit').addEventListener('click', sluit);
    scherm.addEventListener('click', sluit);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluit(); });

    kaartenEl.addEventListener('click', function (e) {
      var k = e.target.closest('.gtb__kaart');
      if (!k) return;
      // zolang de set niet volledig is, altijd verder bij het eerste lege vak; daarna kan elk vak gewijzigd worden
      var leeg = eersteOpen(0);
      openPaneel(leeg >= 0 ? leeg : +k.getAttribute('data-i'));
    });

    // --- toevoegen via het Dawn-formulier -----------------------------------
    var velden = {};
    function vulVelden() {
      if (!form) return;
      vakken.forEach(function (v) {
        var f = velden[v.naam];
        if (!f) {
          f = document.createElement('input');
          f.type = 'hidden';
          f.name = 'properties[' + v.naam + ']';
          form.appendChild(f);
          velden[v.naam] = f;
        }
        f.value = klaar(v) ? propWaarde(v) : '';
      });
    }
    if (form) {
      // vangnet: nooit toevoegen zonder volledige keuze
      form.addEventListener('submit', function (e) {
        if (eersteOpen(0) >= 0) { e.preventDefault(); e.stopImmediatePropagation(); openPaneel(eersteOpen(0)); }
        else vulVelden();
      }, true);
    }
    function actie() {
      var i = eersteOpen(0);
      if (i >= 0) { openPaneel(i); return; }
      if (!form) return;
      vulVelden();
      if (form.requestSubmit) form.requestSubmit(); else if (dawnKnop) dawnKnop.click();
    }
    knop.addEventListener('click', actie);
    balkKnop.addEventListener('click', actie);
    // laadstatus van de Dawn-knop spiegelen
    if (dawnKnop && window.MutationObserver) {
      new MutationObserver(function () {
        var bezig = dawnKnop.classList.contains('loading');
        [knop, balkKnop].forEach(function (b) { b.setAttribute('aria-busy', bezig ? 'true' : 'false'); });
      }).observe(dawnKnop, { attributes: true, attributeFilter: ['class'] });
    }

    // --- vaste balk: zichtbaar zodra de eigen knop uit beeld is ---------------
    var knopZicht = true;
    function balkCheck() {
      var aan = !knopZicht && open < 0 && leverbaar && C.beschikbaar;
      balk.classList.toggle('gtb-balk--zicht', aan);
      document.documentElement.classList.toggle('gtb-balk-aan', aan && window.innerWidth < 990);
    }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (e) { knopZicht = e[0].isIntersecting; balkCheck(); }).observe(knop);
    }

    teken();

    // productfoto's van de keuzes alvast laden, zodat het paneel meteen gevuld is
    function voorladen() {
      var gezien = {};
      C.vakken.forEach(function (t) { data(t).forEach(function (v) { if (v.img && !gezien[v.img]) { gezien[v.img] = 1; new Image().src = v.img; } }); });
    }
    if (document.readyState === 'complete') setTimeout(voorladen, 300); else window.addEventListener('load', function () { setTimeout(voorladen, 300); });
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('.gtb'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
